import React from 'react';
import * as styles from './styles.scss';

const H2 = ({ children, className, ...props }) => (
    <h2
        className={`${styles.title}${className ? ` ${className}` : ''}`}
        {...props}
    >
        {children}
    </h2>
);

export default H2;
